import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AppService } from '../../services/app.service';

interface IMonth {
    index: number;
    name: string;
    disabled?: boolean;
}

@Component({
    selector: 'app-on-call-shift-month',
    templateUrl: './month.component.html'
})
export class OnCallShiftMonthComponent {
    constructor(
        private app: AppService,
        private activeModal: NgbActiveModal
    ) {
        const now = new Date();

        this.currentYear = now.getFullYear();
        this.currentMonth = now.getMonth();

        let month: IMonth;

        for (let i = 0; i < 6; i++) {
            this.years.push(this.currentYear - i);
        }

        for (let i = 0; i < 12; i++) {
            const dt = new Date();
            dt.setMonth(i);

            let name = dt.toLocaleDateString(this.app.currentLanguage, { month: 'long' });
            name = name[0].toUpperCase() + name.substring(1);

            const opt: IMonth = {
                index: i,
                name
            };

            if (i == this.currentMonth) {
                month = opt;
            }

            this.allMonths.push(opt);
        }

        this.year = this.currentYear;
        this.month = month;

        this.onYearChange();
    }

    readonly years: number[] = [];

    year: number;
    month: IMonth;

    get months(): IMonth[] {
        return this.allMonths.filter(t => !t.disabled);
    }

    private readonly currentYear: number;
    private readonly currentMonth: number;
    private readonly allMonths: IMonth[] = [];

    onYearChange() {
        if (this.year === this.currentYear) {
            if (this.month.index > this.currentMonth) {
                this.month = undefined;
            }

            this.allMonths.forEach(t => {
                t.disabled = t.index > this.currentMonth;
            });
        } else {
            this.allMonths.forEach(t => {
                t.disabled = false;
            });
        }
    }

    ok() {
        this.activeModal.close({
            month: this.month.index,
            year: this.year
        });
    }

    cancel() {
        this.activeModal.dismiss();
        this.app.navigateByUrl('/on-call-shifts');
    }
}
